import 'core-js/es6';
import 'core-js/es7';

import '@libs/unified-ui-framework/src/assets/scss/uuif.scss';
import './assets/scss/main.scss';

import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import { appConfigService, appInitService } from '@/core';

import Bootstrap from './bootstrap.vue';

appInitService.initViewMode(router, store);

new Vue({
  router,
  store,
  el: '#app',
  template: '<Bootstrap/>',
  created() {
    appConfigService.periodicSync(this.$store);
  },
  beforeDestroy() {
    appConfigService.stopPeriodicSync();
  },
  components: { Bootstrap },
});
